import controller from './closings.controller';
import template from './closings.html';

const taxationClosingsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default taxationClosingsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/closings/closings.component.js
 **/